import { Spinning } from './components/Spinning'

export { Spinning }

export default { Spinning }
